/**
 * SpecialistID — Product PDP modular bundle: STICKY HEADER
 * Part of the custom-product-* set (split out of the legacy custom-product.js).
 *
 * Watches scroll position and toggles sticky-nav / sticky-nav-wrapper classes
 * on the header and body when the user scrolls past the header bottom.
 *
 * No public API — self-initialising on DOMContentLoaded.
 *
 * LOAD ORDER: after custom-product-core.js (provides SPID.debounce),
 * before custom-product.js.
 */
(function () {
  'use strict';

  const debounce = window.SPID.debounce;

  document.addEventListener('DOMContentLoaded', function() {
    const nav = document.querySelector('sticky-header.header-wrapper');
    if (!nav) return;

    let lastScrollY = window.scrollY;
    let navIsSticky = false;

    function toggleStickyNav() {
      const navHeight = nav.offsetHeight;
      const navBottom = nav.getBoundingClientRect().bottom;
      const shouldStick = navBottom <= 0 && window.scrollY > lastScrollY;
      const shouldUnstick = window.scrollY <= lastScrollY && window.scrollY <= navHeight;

      if (shouldStick && !navIsSticky) {
        nav.classList.add('sticky-nav');
        document.body.classList.add("sticky-nav-wrapper");
        navIsSticky = true;
      } else if (shouldUnstick && navIsSticky) {
        nav.classList.remove('sticky-nav');
        document.body.classList.remove("sticky-nav-wrapper");
        navIsSticky = false;
      }

      lastScrollY = window.scrollY;
    }

    // Debounce scroll events to improve performance
    window.addEventListener('scroll', debounce(toggleStickyNav, 10));
  });

  // Announce this module so main-product.liquid can leave it out safely.
  if (window.SPID && SPID.register) SPID.register('sticky-header');
})();
